const getCss = (file: string) => require('../stylesheets/' + file + '.less');

// const html = (file: string) => require('../html/' + file + '.html');

// const any = html('pricing');
// console.log(any);

const queryParams: any = () =>
    _.chain(location.search.slice(1).split('&'))
        .map(item => item.split('=')).compact().object().value();

const getAngular = (lib: string) => `https://cdnjs.cloudflare.com/ajax/libs/angular.js/1.6.2/angular-${lib}.min.js`;

export const playerUrl = () => {
    let search  = queryParams(),
        version = search.pVer || (location.host.indexOf('nightly') === 0 ? 'nightly' : 'latest'),
        min     = options.isProduction,
        dev     = !options.isProduction,
        salt    = search.pSalt === 'on' ? new Date().getTime() : options.salt;
    if (search.pMin === 'off') min = false;
    if (search.pMin === 'on') min = true;
    if (search.pDev === 'off') dev = false;
    if (search.pDev === 'on') dev = true;

    const url = `https://player${dev ? '-dev' : ''}.animatron.com/${version}/bundle/animatron${min ? '.min' : ''}.js?${salt}`;
    return search.pUrl || url;
};

export const SimpleMDEUrl = 'https://cdn.jsdelivr.net/simplemde/latest/simplemde.min.js';

export const jqueryPaymentLib = [
    'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.2.1/jquery.min.js',
    'https://cdnjs.cloudflare.com/ajax/libs/jquery.payment/1.3.2/jquery.payment.min.js'
];

export const masonryLib = 'https://cdnjs.cloudflare.com/ajax/libs/masonry/4.1.0/masonry.pkgd.min.js';

export const flickityLib = 'https://cdnjs.cloudflare.com/ajax/libs/flickity/2.0.10/flickity.pkgd.min.js';

export const twitterWidgetLib = 'https://platform.twitter.com/widgets.js';

export const fbSDKlib = `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.11&appId=${options.social.facebookApiKey}`;

export const linkedinLib = '//platform.linkedin.com/in.js';

export const googleLib = 'https://apis.google.com/js/platform.js';

export const tapfiliateLib = '//static.tapfiliate.com/tapfiliate.js';

export const animatronProject = [
    getCss('projects'),
    getCss('user-popup'),
    getCss('comments')
];

const angularMessages: oc.IModuleConfig = {
    name: 'ngMessages',
    files: [getAngular('messages')]
};

export const videoTemplatesContainer = () => require.ensure([], () => {
    require('./directives/videoTemplatesContainer');
    return {
        name: 'animatronApp.videoTemplatesContainer',
        files: []
    };
});

export const datePicker = () => Promise.resolve({
    name: 'datePicker',
    files: ['https://cdn.rawgit.com/g00fy-/angular-datepicker/8c46855bed78ff7f0b523a794c7bdaabb558d081/dist/angular-datepicker.min.js',
        'https://cdn.rawgit.com/g00fy-/angular-datepicker/8c46855bed78ff7f0b523a794c7bdaabb558d081/dist/angular-datepicker.min.css']
});

export const animatronTitleBlock = () => require.ensure([], () => {
    require('./landing-template/components/TitleBlock');
    return {
        name: 'animatronApp.titleBlock',
        files: [getCss('landing-template/components/title-block')]
    };
});

export const animatronRelationList = () => require.ensure([], () => {
    require('./landing-template/components/RelationList');
    return {
        name: 'animatronApp.relationList',
        files: [getCss('landing-template/components/relation-list')]
    };
});

export const animatronButtonStart = () => require.ensure([], () => {
    require('./landing-template/components/ButtonStart');
    return {
        name: 'animatronApp.buttonStart',
        files: []
    };
});

export const animatronBackground = () => require.ensure([], () => {
    require('./landing-template/components/Background');
    return {
        name: 'animatronApp.background',
        files: [getCss('landing-template/components/background')]
    };
});

export const animatronIconTextList = () => require.ensure([], () => {
    require('./landing-template/components/IconTextList');
    return {
        name: 'animatronApp.iconTextList',
        files: [getCss('landing-template/components/icon-text-list')]
    };
});

// contest landing
export const animatronContestLandingSvc = () => require.ensure([], () => {
    require('./contest-landing/ContestLandingSvc');
    return {
        name: 'animatronApp.contestLandingSvc',
        files: []
    };
});

export const animatronChallengesList = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ChallengesList');
    return {
        name: 'animatronApp.challengesList',
        files: [getCss('contest-landing/challenges-list')]
    };
}), wistiaPlayer(), animatronContestGoChallengeButton(), animatronContestLandingSvc()]);

export const animatronJudgeItem = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/JudgeItem');
    return {
        name: 'animatronApp.judgeItem',
        files: [getCss('contest-landing/judge-item')]
    };
})]);

export const animatronContestGoChallengeButton = () => require.ensure([], () => {
    require('./contest-landing/ContestGoChallengeButton');
    return {
        name: 'animatronApp.contestGoChallengeButton',
        files: []
    };
});

export const animatronCountdown = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/Countdown');
    return {
        name: 'animatronApp.countdown',
        files: [getCss('contest-landing/countdown')]
    };
})]);

export const animatronPreRegister = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/PreRegister');
    return {
        name: 'animatronApp.preRegister',
        files: [getCss('contest-landing/pre-register')]
    };
})]);

export const animatronSpreadInSocial = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/SpreadInSocial');
    return {
        name: 'animatronApp.spreadInSocial',
        files: [getCss('contest-landing/spread-in')]
    };
}),
    animatronTwitterShareButton(),
    animatronFacebookShareButton(),
    animatronLinkedinShareButton(),
    animatronGoogleShareButton(),
]);

export const animatronSponsorContactUs = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/SponsorContactUs');
    return {
        name: 'animatronApp.sponsorContactUs',
        files: [getCss('contest-landing/sponsor-contact-us')]
    };
})]);

export const animatronTitleShadowBlock = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/TitleShadowBlock');
    return {
        name: 'animatronApp.titleShadowBlock',
        files: [getCss('contest-landing/title-shadow-block')]
    };
})]);

export const animatronParticipateSteps = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ParticipateSteps');
    return {
        name: 'animatronApp.ParticipateSteps',
        files: [getCss('contest-landing/participate-steps')]
    };
})]);

export const animatronVideoImproveSteps = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/VideoImproveSteps');
    return {
        name: 'animatronApp.videoImproveSteps',
        files: [getCss('contest-landing/video-improve-steps')]
    };
}), animatronBackground()]);

export const animatronWinPrizesList = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/WinPrizesList');
    return {
        name: 'animatronApp.winPrizesList',
        files: [getCss('contest-landing/win-prizes-list')]
    };
})]);

export const animatronWinPrizesSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/WinPrizesSection');
    return {
        name: 'animatronApp.winPrizesSection',
        files: [getCss('contest-landing/win-prizes-section')]
    };
}), animatronTitleShadowBlock(), animatronContestLandingSvc()]);

export const animatronCountdownSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/CountdownSection');
    return {
        name: 'animatronApp.countdownSection',
        files: [getCss('contest-landing/countdown-section')]
    };
}), animatronCountdown(), animatronTitleBlock(), animatronBackground()]);

export const animatronContestDaysTopSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContestDaysTopSection');
    return {
        name: 'animatronApp.contestDaysTopSection',
        files: [getCss('contest-landing/contest-days-top-section')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronContestGoChallengeButton()]);

export const animatronContactUsSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContactUsSection');
    return {
        name: 'animatronApp.contactUsSection',
        files: [getCss('contest-landing/contact-us-section')]
    };
}),
    animatronBackground(),
    animatronPreRegister(),
    animatronSponsorContactUs(),
    animatronSpreadInSocial()
]);

export const animatronPreRegisterSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/PreRegisterSection');
    return {
        name: 'animatronApp.preRegisterSection',
        files: [getCss('contest-landing/pre-register-section')]
    };
}), animatronPreRegister(), animatronBackground()]);

export const animatronMediaSponsorsSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/MediaSponsorsSection');
    return {
        name: 'animatronApp.mediaSponsorsSection',
        files: [getCss('contest-landing/media-sponsors-section')]
    };
})]);

export const animatronChallengesListSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ChallengesListSection');
    return {
        name: 'animatronApp.challengesListSection',
        files: [getCss('contest-landing/challenges-list-section')]
    };
}),
    animatronTitleShadowBlock(),
    animatronChallengesList(),
    wistiaPlayer(),
    animatronTitleShadowBlock(),
    animatronContestLandingSvc(),
    animatronContestGoChallengeButton(),
]);

export const animatronContestTextVideoSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContestTextVideoSection');
    return {
        name: 'animatronApp.contestTextVideoSection',
        files: [getCss('contest-landing/contest-text-video-section')]
    };
}), wistiaPlayer(), animatronContestGoChallengeButton()]);

export const animatronVideoImproveStepsSection = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/VideoImproveStepsSection');
    return {
        name: 'animatronApp.videoImproveStepsSection',
        files: [getCss('contest-landing/video-improve-steps-section')]
    };
}), animatronVideoImproveSteps(), animatronTitleShadowBlock(), animatronBackground(), wistiaPlayer()]);

export const animatronContestLanding = () => Promise.all<any>([require.ensure([], () => {
    require('./contest-landing/ContestLanding');
    return {
        name: 'animatronApp.contestLanding',
        files: [getCss('contest-landing/contest-landing')]
    };
}),
    animatronWinPrizesSection(),
    animatronCountdownSection(),
    animatronContactUsSection(),
    animatronContestLandingSvc(),
    animatronPreRegisterSection(),
    animatronMediaSponsorsSection(),
    animatronChallengesListSection(),
    animatronContestDaysTopSection(),
    animatronContestTextVideoSection(),
    animatronVideoImproveStepsSection()
]);

export const animatronContestDays = () => Promise.all([require.ensure([], () => {
    require('./contest-landing/ContestDays');
    return {
        name: 'animatronApp.contestDays',
        files: [getCss('contest-landing/contest-days')]
    };
}),
    animatronJudgeItem(),
    animatronWinPrizesSection(),
    animatronContactUsSection(),
    animatronParticipateSteps(),
    animatronPreRegisterSection(),
    animatronMediaSponsorsSection(),
    animatronContestDaysTopSection(),
    animatronContestTextVideoSection(),
]);
// END contest components

export const animatronDifferentDevices = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/DifferentDevices');
    return {
        name: 'animatronApp.differentDevices',
        files: [getCss('landing-template/components/different-devices')]
    };
}), animatronBackground(), wistiaPlayer()]);

export const animatronSuccessStoriesListItem = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/SuccessStoriesListItem');
    return {
        name: 'animatronApp.successStoriesListItem',
        files: [getCss('landing-template/components/success-stories-list-item')]
    };
}), animatronBackground()]);

export const animatronSuccessStoriesList = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/SuccessStoriesList');
    return {
        name: 'animatronApp.successStoriesList',
        files: [getCss('landing-template/components/success-stories-list')]
    };
}), animatronSuccessStoriesListItem()]);

export const animatronSectionSuccessStoriesList = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionSuccessStoriesList');
    return {
        name: 'animatronApp.sectionSuccessStoriesList',
        files: [getCss('landing-template/components/sections/section-success-stories-list')]
    };
}), animatronSuccessStoriesList()]);

export const animatronSectionBackgroundText = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionBackgroundText');
    return {
        name: 'animatronApp.sectionBackgroundText',
        files: [getCss('landing-template/components/sections/section-background-text')]
    };
}), animatronTitleBlock(), animatronBackground()]);

export const animatronSectionBitmap = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionBitmap');
    return {
        name: 'animatronApp.sectionBitmap',
        files: [getCss('landing-template/components/sections/section-bitmap')]
    };
}), animatronTitleBlock()]);

export const animatronSectionFeedback = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionFeedback');
    return {
        name: 'animatronApp.sectionFeedback',
        files: [getCss('landing-template/components/sections/section-feedback')]
    };
}), animatronTitleBlock(), animatronFeedback()]);

export const animatronSectionHorizontalTextVideo = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionHorizontalTextVideo');
    return {
        name: 'animatronApp.sectionHorizontalTextVideo',
        files: [getCss('landing-template/components/sections/section-horizontal-text-video')]
    };
}), animatronTitleBlock(), animatronButtonStart(), wistiaPlayer()]);

export const animatronSectionHorizontalImageText = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionHorizontalImageText');
    return {
        name: 'animatronApp.sectionHorizontalImageText',
        files: [getCss('landing-template/components/sections/section-horizontal-image-text')]
    };
}), animatronTextBlock(), animatronButtonStart(), animatronBackground()]);

export const animatronSectionVerticalTextVideo = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVerticalTextVideo');
    return {
        name: 'animatronApp.sectionVerticalTextVideo',
        files: [getCss('landing-template/components/sections/section-vertical-text-video')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronButtonStart(), wistiaPlayer()]);

export const animatronSectionDifferentDevices = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionDifferentDevices');
    return {
        name: 'animatronApp.sectionDifferentDevices',
        files: [getCss('landing-template/components/sections/section-different-devices')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronDifferentDevices(), animatronButtonStart()]);

export const animatronSectionCompanyInfo = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionCompanyInfo');
    return {
        name: 'animatronApp.sectionCompanyInfo',
        files: [getCss('landing-template/components/sections/section-company-info')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronIconTextList()]);

export const animatronSectionVideoStatistics = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoStatistics');
    return {
        name: 'animatronApp.sectionVideoStatistics',
        files: [getCss('landing-template/components/sections/section-video-statistics')]
    };
}), animatronTitleBlock(), animatronDoubleCircleProgress()]);

export const animatronSectionCompanyQuote = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionCompanyQuote');
    return {
        name: 'animatronApp.sectionCompanyQuote',
        files: [getCss('landing-template/components/sections/section-company-quote')]
    };
}), animatronBackground()]);

export const animatronSectionTextAside = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionTextAside');
    return {
        name: 'animatronApp.sectionTextAside',
        files: [getCss('landing-template/components/sections/section-text-aside')]
    };
}), animatronTitleBlock(), animatronRelationList()]);

export const animatronSectionSignUp = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionSignUp');
    return {
        name: 'animatronApp.sectionSignUp',
        files: [getCss('landing-template/components/sections/section-sign-up')]
    };
}), animatronBackground(), animatronSignUpBlock(), animatronTextBlock()]);

export const animatronSectionLogoVideoSignUp = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionLogoVideoSignUp');
    return {
        name: 'animatronApp.sectionLogoVideoSignUp',
        files: [getCss('landing-template/components/sections/section-logo-video-sign-up')]
    };
}), animatronTextBlock(), animatronBackground(), animatronSignUpBlock()]);

export const animatronSectionVideoSignUp = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoSignUp');
    return {
        name: 'animatronApp.sectionVideoSignUp',
        files: [getCss('landing-template/components/sections/section-video-sign-up')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronSignUpBlock(), scrollButton()]);

export const animatronSectionVideoTime = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoTime');
    return {
        name: 'animatronApp.sectionVideoTime',
        files: [getCss('landing-template/components/sections/section-video-time')]
    };
}), animatronTitleBlock(), animatronBackground(), animatronButtonStart(), wistiaPlayer(), scrollButton()]);

export const animatronSectionVideoGallery = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoGallery');
    return {
        name: 'animatronApp.sectionVideoGallery',
        files: [getCss('landing-template/components/sections/section-video-gallery')]
    };
}), animatronTitleBlock(), animatronVideoGallery(), animatronButtonStart()]);

export const animatronSectionVideoSteps = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/sections/SectionVideoSteps');
    return {
        name: 'animatronApp.sectionVideoSteps',
        files: [getCss('landing-template/components/sections/section-video-steps')]
    };
}), animatronTitleBlock(), videoSteps(), animatronButtonStart()]);

export const animatronLandingTemplate: any = () => Promise.all<any>([require.ensure([], () => {
    require('./landing-template/LandingTemplate');
    return {
        name: 'animatronApp.landingTemplate',
        files: [
            getCss('landing-template/landing-template')
        ]
    };
}),
    animatronSectionSuccessStoriesList(),
    animatronSectionBackgroundText(),
    animatronSectionLogoVideoSignUp(),
    animatronSectionVideoSignUp(),
    animatronSectionVideoStatistics(),
    animatronSectionVideoTime(),
    animatronSectionBitmap(),
    animatronSectionHorizontalTextVideo(),
    animatronSectionCompanyInfo(),
    animatronSectionHorizontalImageText(),
    animatronSectionTextAside(),
    animatronSectionCompanyQuote(),
    animatronSectionDifferentDevices(),
    animatronSectionVerticalTextVideo(),
    animatronSectionVideoGallery(),
    animatronSectionSignUp(),
    animatronSectionFeedback(),
    animatronSectionVideoSteps()
]);

const userInfoForm = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/UserInfoForm');
        resolve([{
            name: 'animatronApp.userInfoForm',
            files: [
                getCss('user-info-form'),
                getCss('dropdown-menu'),
                getCss('newsWebsite'),
                getCss('_checkbox')
            ]
        }, angularMessages]);
    });
});

export const bgVideoSlider = () => Promise.all([require.ensure([], () => {
    require('./directives/bgVideoSlider');
    return {
        name: 'animatronApp.bgVideoSlider',
        files: []
    };
}), bgVideo()]);

export const modalVideoPlayer = () => Promise.all([require.ensure([], () => {
    require('./directives/modalVideoPlayer');
    return {
        name: 'animatronApp.modalVideoPlayer',
        files: [getCss('modal-video-player')]
    };
}), videoPlayer()]);

export const mainLanding = () => Promise.all([require.ensure([], () => {
    require('./directives/mainLanding');
    return {
        name: 'animatronApp.mainLanding',
        files: [
            getCss('landing/any-landing'),
            options.handHeld ? getCss('mobile/m-any-landing') : ''
        ]
    };
})]);

export const tagsInput = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('ng-tags-input.js');
        resolve({name: 'ngTagsInput', files: [getCss('ng-tags-input')]});
    });
});

export const scrollFixedElement = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/scrollFixedElementDirective');
        resolve({name: 'animatronApp.scrollFixedElement', files: []});
    });
});

export const waveUserPage = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveUserPage');
    return {
        name: 'animatronApp.waveUserPage',
        files: [getCss('wave/wave-user-page')]
    };
}), waveProjects()]);

export const bgVideo = () => require.ensure([], () => {
    require('./directives/bgVideo');
    return {
        name: 'animatronApp.bgVideo',
        files: [getCss('bg-video')]
    };
});

export const scrollButton = () => require.ensure([], () => {
    require('./directives/scrollButton');
    return {
        name: 'animatronApp.scrollButton',
        files: [getCss('scroll-button')]
    };
});

export const ytPlayer = () => require.ensure([], () => {
    require('./directives/ytPlayer');
    return {
        name: 'animatronApp.ytPlayer',
        files: []
    };
});

export const videoPlayer = () => require.ensure([], () => {
    require('./directives/videoPlayer');
    return {
        name: 'animatronApp.videoPlayer',
        files: [getCss('video-player')]
    };
});


export const wistiaPlayer = () => require.ensure([], () => {
    require('./directives/wistiaPlayer');
    return {
        name: 'animatronApp.wistiaPlayer',
        files: [getCss('wistia-player')]
    };
});

export const videoSlider = () => Promise.all([require.ensure([], () => {
    require('./directives/videoSlider');
    return {
        name: 'animatronApp.videoSlider',
        files: [getCss('video-slider')]
    };
}), videoPlayer()]);

const ticker = () => new Promise(resolve => {
    require.ensure([], () => {
        require('./services/Ticker');
        resolve({name: 'animatronApp.ticker', files: []});
    });
});

const animatronRandomNumber = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/randomFact');
        resolve({
            name: 'animatronApp.randomFact',
            files: [getCss('settings/random-fact')]
        });
    });
});

export const animatronUpgrade = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        try {angular.module('animatronApp.settings');} catch (e) {angular.module('animatronApp.settings', []);}
        require('./settings/directives/Subscriptions');
        require('./settings/directives/stripeFormDirective');
        require('./settings/directives/securePaymentDirective');
        require('./settings/directives/couponDirective');
        require('./settings/directives/upgradePlanDirective');
        require('./settings/directives/subscriptionPriceBlock');
        require('./settings/directives/subscriptionTypes');
        require('./settings/directives/infoAppSumo');
        require('./settings/directives/subscriptionPlanDirective');
        require('./settings/services/SubscriptionSvc');
        require('./directives/PlanAnimation');
        require('./settings/services/TypeformSvc');
        resolve([{
            name: 'animatronApp.settings',
            files: [getCss('settings')]
        }, {name: 'animatronApp.planAnimation', files: []}]);
    });
});

export const animatronSettings = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        try {angular.module('animatronApp.settings');} catch (e) {angular.module('animatronApp.settings', []);}
        require('./settings/controllers/SettingsCtrl');
        require('./settings/controllers/ProfileCtrl');
        require('./settings/controllers/PasswordCtrl');
        require('./settings/controllers/NotificationCtrl');
        require('./settings/directives/deleteAccount');
        require('./settings/directives/avatarUploadDirective');
        require('./settings/directives/AddressDirective');
        resolve({
            name: 'animatronApp.settings',
            files: [
                getCss('tabs'),
                getCss('newsWebsite')
            ]
        });
    });
}), animatronRandomNumber(), animatronUpgrade(), userInfoForm()]);

export const animatronTutorial = () => new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.tutorial', []);
        require('tutorial.html');
        require('tutorials/tutorial-video.html');
        require('./directives/TutorialComponent');
        require('./directives/TutorialModal');
        require('./services/TutorialSvc');
        require('./directives/tutorialVideoDirective');
        require('./directives/youtubeModalDirective');
        resolve({
            name: 'animatronApp.tutorial',
            files: [
                getCss('tutorial'),
                getCss('tabs'),
                getCss('search')
            ]
        });
    });
});

export const animatronSpecialUpgrade = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        try {angular.module('animatronApp.settings');} catch (e) {angular.module('animatronApp.settings', []);}
        require('./directives/SpecialUpgrade');
        resolve({
            name: 'animatronApp.special-upgrade',
            files: [getCss('special-upgrade')]
        });
    });
}), animatronUpgrade()]);

export const animatronFeedback = () => new Promise<oc.IModuleConfig>(resolve => {
    angular.module('animatronApp.feedback', []);

    require.ensure([], () => {
        require('./directives/randomFeedbackDirective');
        require('./directives/feedbackSlider');
        require('./directives/FeedbackSwipable');
        require('./directives/feedbacksListDirective');
        require('./services/OurFeedbackSvc');
        resolve({
            name: 'animatronApp.feedback',
            files: [getCss('feedback-slider')]
        });
    });
});

export const animatronEdu = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.education', []);
        require('./directives/EducationComponent');
        require('./directives/eduExampleProject');
        require('education/education.html');
        resolve({
            name: 'animatronApp.education',
            files: [
                getCss('edu'),
                getCss('signup')
            ]
        });
    });
}), animatronTutorial()]);

export const animatronPrivacy       = [getCss('tutorial')];
export const animatronTermsServices = [getCss('tutorial')];

export const animatronPricing = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.pricing', []);
        require('./directives/pricingSubscriptionDirective');
        require('./directives/PlanAnimation');
        resolve([{
            name: 'animatronApp.pricing',
            files: [
                getCss('pricing'),
                options.handHeld ? getCss('mobile/m-landing-bottom') : ''
            ]
        }, {name: 'animatronApp.planAnimation', files: []}]);
    });
}), animatronFeedback(), animatronUpgrade()]);

export const wavePricing = () => Promise.all([require.ensure([], () => {
    angular.module('animatronApp.wavePricing', []);
    require('./wave/wavePricing');

    return {
        name: 'animatronApp.wavePricing',
        files: [
            getCss('wave/wave-pricing'),
            options.handHeld ? getCss('mobile/wave/m-wave-pricing') : ''
        ]
    };
}), animatronPricing(), animatronSectionHorizontalImageText()]);

const animatronCanvas = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./landing_bottom/animatronCanvas');
        resolve({name: 'animatronApp.animatronCanvas', files: []});
    });
});

export const animatronVideoGallery = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/landing/VideoGallery');
        resolve({
            name: 'animatronApp.videoGallery',
            files: [
                getCss('landing/video-gallery')
            ]
        });
    });
});

export const animatronExplainerGallery = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        require('./directives/landing/ExplainerGallery');
        resolve({name: 'animatronApp.explainerGallery', files: [getCss('landing/masonry-wrapper')]});
    });
});

export const animatronSignup = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/signupFormDirective');
        resolve([angularMessages, {
            name: 'animatronApp.signup',
            files: [
                // getHtml('signup/sign-up'),
                getCss('signup'),
                getCss('sign-up-block')
            ]
        }]);
    });
});

export const introduceVideo = () => require.ensure([], () => {
    require('./directives/introduceVideo');
    return {
        name: 'animatronApp.introduce-video',
        files: []
    };
});

export const animatronBannerBottom = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.bannerBottom', []);
        require('./directives/landing/LandingSignup');
        require('./directives/landing/BannerGallery');
        require('./landing_bottom/PlayerPlayOnMouse');
        resolve({
            name: 'animatronApp.bannerBottom',
            files: [
                require('landing/landing-top-footer.html'),
                getCss('landing/banner-bottom'),
                options.handHeld ? getCss('mobile/m-landing-banner') : ''
            ]
        });
    });
}), animatronFeedback(), animatronCanvas(), animatronVideoGallery()]);


export const animatronMediumLanding = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.mediumLanding', []);
        require('./directives/landing/MediumLanding');
        resolve({
            name: 'animatronApp.mediumLanding',
            files: [
                getCss('landing/medium-landing'),
                options.handHeld && getCss('mobile/m-medium-landing')
            ]
        });
    });
}), animatronCanvas(), animatronVideoGallery(), bgVideo(), videoSlider(), animatronFeedback()]);

export const animatronComparisonBottom = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.comparisonBottom', []);
        resolve({
            name: 'animatronApp.comparisonBottom',
            files: [
                getCss('landing/comparison'),
                options.handHeld ? getCss('mobile/m-landing-comparison') : '',
                getCss('tabs')
            ]
        });
    });
}), scrollFixedElement()]);

export const animatronLandingNewBottom = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.landingNewBottom', []);
        require('./directives/landing/LaptopVideo');
        require('./directives/landing/LandingGallery');
        require('landing/landing-new-bottom.html');
        require('landing/landing-top-footer.html');
        require('landing/feedback-swipable.html');
        resolve({
            name: 'animatronApp.landingNewBottom',
            files: [
                getCss('landing/masonry-wrapper'),
                getCss('tabs'),
                getCss('landing/landing-new-bottom')
            ]
        });
    });
}), ytPlayer(), animatronFeedback(), wistiaPlayer()]);

export const animatronExplainerBottom = animatronBannerBottom;

export const animatronAbout = () => new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/googleMapDirective');
        resolve({name: 'animatronApp.about', files: [getCss('about')]});
    });
});

export const animatronTwitterFollowButton = () => require.ensure([], () => {
    require('./directives/twitterFollowButton');
    return {
        name: 'animatronApp.twitterFollowButton',
        files: []
    };
});

export const animatronTwitterShareButton = () => require.ensure([], () => {
    require('./directives/twitterShareButton');
    return {
        name: 'animatronApp.twitterShareButton',
        files: []
    };
});

export const animatronFacebookShareButton = () => require.ensure([], () => {
    require('./directives/facebookShareButton');
    return {
        name: 'animatronApp.facebookShareButton',
        files: [getCss('f_bsh-button')]
    };
});

export const animatronLinkedinShareButton = () => require.ensure([], () => {
    require('./directives/linkedinShareButton');
    return {
        name: 'animatronApp.linkedinShareButton',
        files: [getCss('le-share-button')]
    };
});

export const animatronGoogleShareButton = () => require.ensure([], () => {
    require('./directives/googleShareButton');
    return {
        name: 'animatronApp.googleShareButton',
        files: [getCss('go-share-button')]
    };
});

export const animatronSignUpBlock = () => require.ensure([], () => {
    require('./directives/signUpBlock');
    return [angularMessages, {
        name: 'animatronApp.signUpBlock',
        files: [getCss('sign-up-block')]
    }];
});

export const animatronDoubleCircleProgress = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/DoubleCircleProgress');
    return {
        name: 'animatronApp.doubleCircleProgress',
        files: [getCss('landing-template/components/double-circle-progress')]
    };
})]);

export const animatronTextBlock = () => Promise.all([require.ensure([], () => {
    require('./landing-template/components/TextBlock');
    return {
        name: 'animatronApp.textBlock',
        files: [getCss('landing-template/components/text-block')]
    };
}), animatronTitleBlock(), animatronButtonStart()]);

export const animatronCompany = () => Promise.all([require.ensure([], () => {
    require('./directives/company');
    return {
        name: 'animatronApp.company',
        files: [
            getCss('company'),
            options.handHeld ? getCss('mobile/m-company') : ''
        ]
    };
}), animatronTwitterFollowButton()]);

export const animatronContractors = () => new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/Contractors');
        resolve({
            name: 'animatronApp.contractors',
            files: [
                getCss('user-section'),
                getCss('contractors')
            ]
        });
    });
});

export const waveMain = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveLanding');
    return {
        name: 'animatronApp.wave.landing',
        files: [
            getCss('wave/wave-landing'),
            options.handHeld ? getCss('mobile/wave/m-wave-landing') : ''
        ]
    };
}), animatronVideoGallery(), bgVideo(), waveSectionHowWork()]);

export const waveLandingSMMW = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveLandingSMMW');
    return {
        name: 'animatronApp.wave.landingSMMW',
        files: [
            getCss('wave/wave-landing-smmw'),
            options.handHeld ? getCss('mobile/wave/m-wave-landing-smmw') : ''
        ]
    };
}), introduceVideo(), waveSectionHowWork(), scrollButton()]);

export const mariSmithTutorials = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/mariSmithTutorials');
    return {
        name: 'animatronApp.wave.mariSmithTutorials',
        files: [
            getCss('wave/wave-mari-smith-tutorials'),
            options.handHeld ? getCss('mobile/wave/m-mari-smith-tutorials') : ''
        ]
    };
})]);

export const waveProject = () => require.ensure([], () => {
    require('./directives/wave/waveProjectItem');
    return {
        name: 'animatronApp.wave.project-item',
        files: [getCss('wave/wave-project-item')]
    };
});

export const waveTutorialWorkshops = () => require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialWorkshops');
    return {
        name: 'animatronApp.wave.tutorialWorkshops',
        files: [getCss('wave/tutorial/wave-tutorial-workshops')]
    };
});

export const waveTutorialsItem = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialsItem');
    return {
        name: 'animatronApp.wave.tutorialsItem',
        files: [getCss('wave/tutorial/wave-tutorials-item')]
    };
}), animatronTutorial()]);

export const waveTutorialsList = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialsList');
    return {
        name: 'animatronApp.wave.tutorialsList',
        files: [getCss('wave/tutorial/wave-tutorials-list')]
    };
}), waveTutorialsItem()]);

export const waveTutorialPage = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/tutorial/TutorialPage');
    return {
        name: 'animatronApp.wave.tutorialPage',
        files: [getCss('wave/tutorial/wave-tutorial-page')]
    };
}), waveTutorialsList(), animatronSectionVerticalTextVideo(), waveTutorialWorkshops(), animatronSectionHorizontalImageText()]);


export const videoSteps = () => Promise.all([require.ensure([], () => {
    require('./directives/videoSteps');
    return {
        name: 'animatronApp.videoSteps',
        files: [getCss('video-steps')]
    };
}), animatronButtonStart(), wistiaPlayer()]);

export const waveSectionHowWork = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveSectionHowWork');
    return {
        name: 'animatronApp.wave.sectionHowWork',
        files: [getCss('wave/wave-section-how-work')]
    };
}), videoSteps()]);

export const waveTemplate = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveTemplateItem');
    return {
        name: 'animatronApp.wave.template-item',
        files: [getCss('wave/wave-template-item')]
    };
}), modalVideoPlayer()]);

export const waveProjects = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveProjects');
    return {
        name: 'animatronApp.wave.projects',
        files: [
            getCss('projects'),
            getCss('wave/wave-projects')
        ]
    };
}), waveProject(), animatronUpgrade(), waveTemplate()]);

export const waveMyProjects = () => Promise.all([require.ensure([], () => {
    require('./directives/wave/waveMyProjects');
    return {
        name: 'animatronApp.wave.my-projects',
        files: [
            getCss('tabs'),
            getCss('wave/wave-my-projects')
        ]
    };
}), waveProjects(), videoTemplatesContainer()]);

export const animatronActivate = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/activate/ActivateEmail');
        require('./directives/activate/ActivateOAuth');
        resolve([angularMessages, {
            name: 'animatronApp.activate',
            files: [
                getCss('activate'),
                // playerUrl()
            ]
        }]);
    });
}), userInfoForm()]);

export const animatronRecovery = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/recovery/RecoveryPage');
        resolve([angularMessages, {
            name: 'animatronApp.recovery',
            files: [getCss('recovery-page')]
        }]);
    });
});

export const animatronRecoveryReset = () => new Promise<oc.IModuleConfig[]>(resolve => {
    require.ensure([], () => {
        require('./directives/recovery/RecoveryResetPage');
        resolve([angularMessages, {
            name: 'animatronApp.recoveryReset',
            files: [getCss('recovery-page')]
        }]);
    });
});

export const animatronProjectAnalytics = () => new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.projectAnalytics', []);
        require('./directives/analytics/ProjectAnalytics');
        require('./directives/analytics/viewsCountAnalyticsDirective');
        require('./directives/analytics/summarizedAnalyticsDirective');
        require('./directives/analytics/detailedViewsAnalyticsDirective');
        resolve({
            name: 'animatronApp.projectAnalytics',
            files: [
                'https://cdnjs.cloudflare.com/ajax/libs/d3/3.5.16/d3.min.js', // consider https://plot.ly/javascript/
                getCss('settings'),
                getCss('analytics'),
                getCss('projects'),
                getCss('tabs'),
                getCss('dropdown-menu')
            ]
        });
    });
});

export const animatronThumbnailPicker = () => new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.thumbnailPicker', []);
        require('./directives/thumbnailPicker');
        resolve({
            name: 'animatronApp.thumbnailPicker',
            files: [getCss('thumbnail-picker')]
        });
    });
});

export const animatronPublish = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.publish', []);
        require('./directives/publishDirective');
        require('./directives/PublishVideo');
        resolve({
            name: 'animatronApp.publish',
            files: [
                getCss('publish'),
                getCss('tabs'),
                getCss('_checkbox')
            ]
        });
    });
}), ticker(), animatronThumbnailPicker()]);

export const animatronProjectPreviewPicker = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.projectPreviewPicker', []);
        require('./directives/projectPreviewPicker');
        resolve({
            name: 'animatronApp.projectPreviewPicker',
            files: [getCss('publish')]
        });
    });
}), animatronThumbnailPicker()]);

export const animatronProjects = () => new Promise<oc.IModuleConfig>(resolve => {
    angular.module('animatronApp.projects', []);
    resolve({
        name: 'animatronApp.projects',
        files: [
            getCss('tabs'),
            getCss('newsWebsite'),
            getCss('search')
        ].concat(animatronProject)
    });
});

export const animatronUserPage = () => Promise.all([new Promise<oc.IModuleConfig>(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.profileProject', []);
        require('./directives/UserPage');
        require('./directives/FollowersPage');
        require('./services/FollowersSvc');
        require('./directives/profileProjectDirective');
        require('./directives/paginationDirective');
        resolve({
            name: 'animatronApp.profileProject',
            files: [getCss('user-section')]
        });
    });
}), animatronProjects()]);

export const animatronEmotions = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.emotions', []);
        require('./directives/EmotionsCampaign');
        resolve({
            name: 'animatronApp.emotions',
            files: [
                getCss('emotions-campaign'),
                getCss('tabs'),
                getCss('_checkbox')
            ]
        });
    });
}), ticker()]);

export const animatronHtml5Offline = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.html5Offline', []);
        require('./directives/DownloadHtml5');
        resolve({
            name: 'animatronApp.html5Offline',
            files: [
                getCss('publish'),
                getCss('tabs'),
                getCss('_checkbox')
            ]
        });
    });
}), animatronThumbnailPicker()]);

//export const animatronSearchPage = [animatronProjects(), getJs('controllers/SearchPageCtrl')];
export const animatronSearchPage = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        require('./directives/SearchPage');
        resolve({
            name: 'animatronApp.searchPage',
            files: [
                getCss('search-page'),
                options.handHeld && getCss('mobile/m-search-page')
            ]
        });
    });
}), animatronProjects()]);

//FIXME might not work
export const animatronContest = () => Promise.all([new Promise(resolve => {
    require.ensure([], () => {
        angular.module('animatronApp.contest', []);
        require('./contest/ContestPage');
        require('./contest/JoinContestsPage');
        require('./contest/MyContestsPage');
        require('./contest/InitiateContestPage');
        resolve({
            name: 'animatronApp.contest',
            files: [
                getCss('contest/contest'),
                getCss('_checkbox')
            ]
        });
    });
}), animatronUserPage(), datePicker()]);



// WEBPACK FOOTER //
// ./app/assets/javascripts/lazy_modules.ts